export default __webpack_public_path__ + "static/media/lampstyle-bg-blue.7a273072.svg";